import {
  BPBeginnenSofortRequest,
  RemoteResult,
  TischPruefenRequest,
  Tisch,
  Terminart,
} from "mangdto"
import router from "@/router"
import store from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"

export default class TerminSofortLogic extends BaseLogic {
  tischNummer: string = null
  tisch: Tisch = null

  pruefenWorking: boolean = false
  pruefenError: boolean = false
  pruefenCompleted: boolean = false

  buchenWorking: boolean = false
  buchenError: boolean = false
  buchenCompleted: boolean = false

  init() {
    this.tischNummer = this.mainLogic.bestellungPending.sofort.tischBezeichnung
  }

  verfuegbarkeitPruefen() {
    this.pruefenWorking = true
    this.pruefenError = false

    var request = new TischPruefenRequest()
    request.id = this.mainLogic.filiale.filialeId
    request.tischNr = this.tischNummer

    Poster.postUser<RemoteResult<Tisch>>(RestPaths.tischPruefen, request)
      .then((response) => {
        this.pruefenWorking = false
        if (response.data.success) {
          this.tisch = response.data.payload

          this.mainLogic.bestellungPending.sofort.tischId = this.tisch.id
          this.mainLogic.bestellungPending.sofort.tischBezeichnung =
            this.tisch.tischnummer

          this.pruefenCompleted = true
        } else {
          this.pruefenError = true
        }
      })
      .catch(() => {
        this.pruefenWorking = false
        this.pruefenError = true
      })
  }

  tischBuchen() {
    this.buchenWorking = true
    this.buchenError = false
    var request = new BPBeginnenSofortRequest()
    request.identifier = store.state.user.identifier
    request.tischId = this.tisch.id

    Poster.postUser<RemoteResult<string>>(
      RestPaths.bestellungpendingBeginnenSofort,
      request,
    )
      .then((response) => {
        this.buchenWorking = false
        if (response.data.success) {
          this.buchenCompleted = true

          this.mainLogic.bestellungPending.terminart =
            Terminart.Sofortbestellung
          this.mainLogic.bestellungPending.sofort.tischId = this.tisch.id
          this.mainLogic.bestellungPending.sofort.tischBezeichnung =
            this.tisch.tischnummer

          if (this.filiale.sofortbestellungSettings.nurSelbstbestellung) {
            router.push({ name: RouteNames.NEU.SHOPPING.PRODUKTE })
          } else {
            router.push({
              name: RouteNames.NEU.SOFORTBESTELLUNG_BESTELLART,
            })
          }
        } else {
          this.buchenError = true
        }
      })
      .catch(() => {
        this.buchenWorking = false
        this.buchenError = true
      })
  }
}
